<template>
  <div>
    <div>      
      <div>        
        <v-row>
              <v-col cols="12">
                    <geoAddr :line1="null"  @onSelect="onPlaceSelected" />            
              </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="2">
            <v-text-field maxlength="10"  type="text" @input="onUnitNumberChange" :label="$t('labels.UnitNumber')" v-model="unitNumber" />
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field type="number" :label="$t('labels.StreetNumber')" v-model="addr.StreetNumber" />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field type="text" :label="$t('labels.StreetName')" v-model="addr.StreetName" />
          </v-col>
          <v-col cols="12" md="3">
            <p_dd menu="StreetType" v-model="addr.StreetTypeDD" :label="$t('labels.StreetType')" />
          </v-col>
          <v-col cols="12" md="2">
            <p_dd menu="StreetDirection" v-model="addr.StreetDirectionDD" :label="$t('labels.Direction')" />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field type="text" v-model="addr.City" :label="$t('labels.City')" />
          </v-col>
          <v-col v-if="!stateFlag"  cols="12" md="3">
            <p_dd menu="Province" v-model="addr.ProvinceDD" :label="$t('labels.Province')" />
          </v-col>
          <v-col v-if="stateFlag"  cols="12" md="3">
            <p_dd2 menu="STATE" v-model="addr.ProvinceDD" :label="$t('labels.State')" />
          </v-col>
          
          <v-col cols="12" md="3">
            <p_dd @input="onchange" menu="CountryType" v-model="addr.CountryTypeDD" :label="$t('labels.Country')" />
          </v-col>
          <v-col v-if="addr.CountryTypeDD == 1" cols="12" md="3">
            <v-text-field type="text" v-model="postalcode" :label="$t('labels.PostalCode')" v-mask="'A#A #A#'" />
          </v-col>
           <v-col v-if="addr.CountryTypeDD == 2" cols="12" md="3">
            <v-text-field type="text" v-model="addr.InternationalPostalCode" :label="$t('labels.ZipCode')"  />
          </v-col>
        </v-row>
      </div>      
    </div>
  </div>
</template>

<script>
import dataSvc from "@/services/dataService";
import p_dd from "@/shared/components/ddSelect";
import p_dd2 from "@/shared/components/ddSelect";
import geoAddr from "@/shared/components/canadaPost";
export default {
  props: ["value", "easyModeFlag"],
  components: {
    p_dd,geoAddr,p_dd2
  },
  data() {
    return {
      easyMode: true,
      unitNumber: null,
      postalcode: null,
      State: null,
      addr: {},
      mapAddress: null,
      stateFlag: false,     
    };
  },
  methods: {
    onchange(){
      if(this.addr.CountryTypeDD == 1){
          this.stateFlag = false;
          this.addr.InternationalPostalCode = null;
          this.addr.ProvinceDD = null;
        }else if(this.addr.CountryTypeDD == 2){
          this.stateFlag = true;
           this.postalcode = null;
          this.addr.ProvinceDD = null;
        }else{
          this.stateFlag = false;
        }
    },
    onUnitNumberChange(){
      return;
      this.addr.UnitNumber = this.unitNumber;       
      this.$emit("input", this.addr);
    },
    switchMode() {
      this.easyMode = !this.easyMode;      
    },
    onPlaceSelected(rv){            
        this.$nextTick(()=>{
            this.addr.City = rv.City;
            this.addr.CountryTypeDD = rv.CountryTypeDD;
            this.addr.PostalFsa = rv.PostalFsa;
            this.addr.PostalLdu = rv.PostalLdu;
            this.addr.StreetDirectionDD = rv.StreetDirectionDD;
            this.addr.StreetName = rv.StreetName;
            this.addr.StreetNumber = rv.StreetNumber;
            this.addr.StreetTypeDD = rv.StreetTypeDD;
            this.addr.ProvinceDD = rv.ProvinceDD;
            this.addr.UnitNumber = rv.Unit;
            this.addr.InternationalPostalCode = rv.InternationalPostalCode;
            this.unitNumber = rv.Unit;

            this.$nextTick(()=>{
                this.postalcode=null;
                this.$nextTick(()=>{
                    this.postalcode = rv.PostalFsa + ' ' + rv.PostalLdu;
                });
            });            
            
            this.mapAddress = null;
            this.addr.AddressLine1 = null;
            this.$emit("input", this.addr);
        });
        
    },
   
  
    setValue() {
      this.addr = this.value;    
      this.unitNumber = this.addr.UnitNumber;
      if(this.addr.PostalFsa && this.addr.PostalLdu)
        this.postalcode = this.addr.PostalFsa + this.addr.PostalLdu;
      else 
        this.postalcode = null;
      this.mapAddress = this.addr.FullAddressWithoutUnit;
    }
  },
  created() {
    this.easyMode = this.easyModeFlag;
  },   
  mounted(){
    this.setValue();
  },
  watch: {
    postalcode(n) {
      if(!n) return;
      if (n.length == 7) {
        this.addr.PostalFsa = n.substr(0, 3);
        this.addr.PostalLdu = n.substr(4, 3);
      } else{
        this.setValue();
      }
    },
    "addr.CountryTypeDD":{
      handler(n,o){        
        if(n == 1){
          this.stateFlag = false;
          // this.addr.InternationalPostalCode = null;
          // this.addr.ProvinceDD = null;
        }else if(n == 2){
          this.stateFlag = true;
          //  this.postalcode = null;
          // this.addr.ProvinceDD = null;
        }else{
          this.stateFlag = false;
        }
      }

    },
    value(n){
      this.setValue();
      
    }
  }
};
</script>

<style scoped>
.addressText {
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.2;
}
</style>